/* global document, Promise */

import * as firebase from 'firebase'
import _ from 'lodash'

import csvSettings from './common/csvSettings'
import CloudFunctionsApisUtils from 'infra/CloudFunctionsApisUtils'

const Utils = {
  splitCustomerContactId : (customerContactId) => {
    if (!customerContactId){
      return {}
    }
    const contactId = customerContactId.split('@')[0]
    const customerId = customerContactId.split('@')[1]
    return { contactId, customerId }
  },

  normalizeCustomer(customer, customerId){
    let id = ''
    if (customerId === customer.id){
      id = customer.customerId
    } else if (customerId === customer.customerId){
      id = customer.id
    }
    return {
      dbKey: customerId,
      //internal customerId
      id,
      name: customer.name
    }
  },

  getNewKey: (path) => {
    return firebase.database().ref(path).push().key
  },

  contactAvailable: (name, email, phoneNumber, address) => {
    return name
           || email
           || phoneNumber
           || address
  },

  createNewCustomerObj(customer, teamId){
    const { name, customerId, email, phoneNumber,
      contactName, address, addressLat, addressLng } = customer
    const basePath = `customers/${teamId}`
    const id = Utils.getNewKey(basePath)
    const contactBasePath = `${basePath}/${id}/contactsList`
    const contactId = Utils.getNewKey(contactBasePath)
    let contact = null
    if (Utils.contactAvailable(contactName, email, phoneNumber, address)){
      contact = {
        id: contactId,
        contactName: contactName || '',
        email: email || '',
        phoneNumber: phoneNumber || '',
        address: address || '',
        addressLat: addressLat || '',
        addressLng: addressLng || ''
      }
    }
    const customerObj = {
      id,
      name: name || '',
      customerId: customerId || '',
      contactsList: {
        [contactId]: contact
      }
    }
    return { customerObj, id, contactId }
  },

  saveCustomerObj(customer, teamId){
    const dbPath = `customers/${teamId}/${customer.id}`
    firebase.database().ref(dbPath).set(customer)
  },

  createNewContactObj(contact, teamId, customerId){
    const { email, phoneNumber, contactName,
      address, addressLat, addressLng } = contact

    const contactBasePath = `customers/${teamId}/${customerId}/contactsList`
    const contactId = contact.id ? contact.id : Utils.getNewKey(contactBasePath)
    let contactObj = {}
    if (Utils.contactAvailable(contactName, email, phoneNumber, address)){
      contactObj = {
        id: contactId,
        contactName: contactName || '',
        email: email || '',
        phoneNumber: phoneNumber || '',
        address: address || '',
        addressLat: addressLat || '',
        addressLng: addressLng || ''
      }
    }

    return { contactObj, contactId }
  },

  saveContactObj(contact, teamId, customerId){
    const dbPath = `customers/${teamId}/${customerId}/contactsList/${contact.id}`
    firebase.database().ref(dbPath).set(contact)
  },

  savePartialCustomerObj(customer, teamId, customerId){
    const updates = {}
    updates[`customers/${teamId}/${customerId}/name`] = customer.name
    updates[`customers/${teamId}/${customerId}/customerId`] = customer.customerId //internal id, not dbKey
    firebase.database().ref().update(updates)
  },

  exportSampleTemplate: () => {
    const headers = [
      'Customer Name',
      'Customer Id',
      'Contact Name',
      'Contact Email',
      'Contact Phone',
      'Contact Address'
    ]
    const line = headers.join(',')
    const csvContent = 'data:text/csv;charset=utf-8,' + line
    const encodedUri = encodeURI(csvContent)
    const link = document.createElement('a')
    link.setAttribute('href', encodedUri)
    link.setAttribute('download', 'customers.csv')
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  },

  uploadCustomersFromCSV : (teamId, customers) => {
    if (!customers.length){
      return
    }
    const toUpload = []
    customers.forEach(customerRow => {
      const customer = {}
      let notEmpty = false
      _.keys(customerRow).forEach(field => {
        if (customerRow[field]){
          notEmpty = true
        }
        const { key } = csvSettings[field]
        customer[key] = customerRow[field]
      })
      if (notEmpty){
        toUpload.push(customer)
      }
    })

    return CloudFunctionsApisUtils
      .importCustomers(teamId, toUpload)
      .then(response => {
        return Promise.resolve(response)
      })

  }
}

export default Utils



// WEBPACK FOOTER //
// ./src/customer/Utils.js